import React, { Component } from "react";
import MetaTags from 'react-meta-tags';
import { translate } from "react-i18next";
import Footer from "../layout/footer";
import RollingLogo from "../widget/rolling_logo";
import Speaker from "../layout/speaker";
// import ConfTimer from "../layout/conf_timer";

import Conf_1 from '../../image/conf/conf_1_university.png';
import Conf_2 from '../../image/conf/conf_2_engineer.png';
import Conf_3 from '../../image/conf/conf_2_y_innovators.png';
import Conf_4 from '../../image/conf/conf_4_it_prof.png';
import Conf_5 from '../../image/conf/conf_5_anyone.png';
import Why_1 from '../../image/conf/why-join_01.png';
import Why_2 from '../../image/conf/why-join_02.png';
import Why_3 from '../../image/conf/why-join_03.png';
import Why_4 from '../../image/conf/why-join_04.png';
import Why_5 from '../../image/conf/why-join_05.png';

class Conf extends Component {
    state = {
        row: 5,
        part1: true,
        why1: true,
        why2: false,
        why3: false,
        why4: false,
        why5: false,
        check: "test",
    }

    handleResize = () => {
        let width = window.innerWidth;
        if (width > 1100) {
            this.setState({ row: 5 });
        } else if (width > 930) {
            this.setState({ row: 4 });
        } else if (width > 768) {
            this.setState({ row: 3 });
        } else {
            this.setState({ row: 2 });
        }
    }
    updatePart = (s) => {
        if (s === 1) {
            this.setState({ part1: true });
        } else {
            this.setState({ part1: false });
        }
    }
    updateWhy = (n) => {
        switch (n) {
            case 1:
                setTimeout(() => {
                    this.setState({ why1: true, why2: false, why3: false, why4: false, why5: false, });
                }, 0);
                break;
            case 2:
                setTimeout(() => {
                    this.setState({ why1: false, why2: true, why3: false, why4: false, why5: false, });
                }, 0);
                break;

            case 3:
                setTimeout(() => {
                    this.setState({ why1: false, why2: false, why3: true, why4: false, why5: false, });
                }, 0);
                break;

            case 4:
                setTimeout(() => {
                    this.setState({ why1: false, why2: false, why3: false, why4: true, why5: false, });
                }, 0);
                break;

            case 5:
                setTimeout(() => {
                    this.setState({ why1: false, why2: false, why3: false, why4: false, why5: true, });
                }, 0);
                break;
            default:
                break;


        }
    }
    goToTheme = () => {
        var d = document.getElementById("theme");
        var topPos = d.offsetTop;
        var header = document.getElementById("nav");
        let headerHeight = header.offsetHeight;

        window.scrollTo({
            top: (topPos - headerHeight),
            left: 0,
            behavior: "smooth"
        });
    }
    goToProgram = () => {
        var d = document.getElementById("programme");
        var topPos = d.offsetTop;
        var header = document.getElementById("nav");
        let headerHeight = header.offsetHeight;

        window.scrollTo({
            top: (topPos - headerHeight),
            left: 0,
            behavior: "smooth"
        });
    }
    goToSpeakers = () => {
        var d = document.getElementById("speakers");
        var topPos = d.offsetTop;
        var header = document.getElementById("nav");
        let headerHeight = header.offsetHeight;

        window.scrollTo({
            top: (topPos - headerHeight),
            left: 0,
            behavior: "smooth"
        });
    }
    goToAudience = () => {
        var d = document.getElementById("audience");
        var topPos = d.offsetTop;
        var header = document.getElementById("nav");
        let headerHeight = header.offsetHeight;

        window.scrollTo({
            top: (topPos - headerHeight),
            left: 0,
            behavior: "smooth"
        });
    }
    goToWhy = () => {
        var d = document.getElementById("why");
        var topPos = d.offsetTop;
        var header = document.getElementById("nav");
        let headerHeight = header.offsetHeight;

        window.scrollTo({
            top: (topPos - headerHeight),
            left: 0,
            behavior: "smooth"
        });
    }
    goToSection = (n) => {
        // console.log(n);
        setTimeout(() => {
            this.setState({ check: n, }, () => {                              
                //callback
                switch (n) {
                    case "theme":
                        this.goToTheme();
                        break;
                    case "programme":
                        this.goToProgram();
                        break;
                    case "speakers":
                        this.goToSpeakers();
                        break;
                    case "audience":
                        this.goToAudience();
                        break;
                    case "why":
                        this.goToWhy();
                        break;
                    default:
                        break;
                }
              });
        }, 500);



    }
    updateVideo(type) {
        let videoSrc;
        if (type === 'session_1') {
            videoSrc = 'https://storage.googleapis.com/emsd_video/1_HKSTP_Opening_Sub_2.mp4';
        } else if (type === 'session_2') {
            videoSrc = 'https://storage.googleapis.com/emsd_video/2_HKSTP_Crystal_Presentation_Sub_2.mp4';
        } else if (type === 'session_3') {
            videoSrc = 'https://storage.googleapis.com/emsd_video/3_0909_1600_Cristina_Sub.mp4';
        } else if (type === 'session_4') {
            videoSrc = 'https://storage.googleapis.com/emsd_video/4_HKSTP_Andrew_Presentation_Sub.mp4';
        } else if (type === 'session_5') {
            videoSrc = 'https://storage.googleapis.com/emsd_video/5_0909_2100_Steven%20T%20Bushby_Sub_3.mp4';
        } else if (type === 'session_6') {
            videoSrc = 'https://storage.googleapis.com/emsd_video/6_HKSTP_Dan_Presentation_Sub.mp4';
        } else if (type === 'session_7') {
            videoSrc = 'https://storage.googleapis.com/emsd_video/7_WanChao_Tencent.mp4';
        } else if (type === 'session_8') {
            videoSrc = 'https://storage.googleapis.com/emsd_video/8_HKSTP_Samson_Presentation_Sub.mp4';
        } else if (type === 'session_9') {
            videoSrc = 'https://storage.googleapis.com/emsd_video/9_0915_0900_Dr%20Youngchoon%20Park_Sub.mp4';
        } else if (type === 'session_11') {
            videoSrc = 'https://storage.googleapis.com/emsd_video/1_0902_2300_Gabe_Sub_2.mp4';
        } else if (type === 'session_12') {
            videoSrc = 'https://storage.googleapis.com/emsd_video/2_0929_0930_Towngas_Sub_3.mp4';
        } else if (type === 'session_13') {
            videoSrc = 'https://storage.googleapis.com/emsd_video/3_0913_0930_Arun%20Vishwanath_Sub.mp4';
        } else if (type === 'session_14') {
            videoSrc = 'https://storage.googleapis.com/emsd_video/4_0930_1100_Microsoft_Sub.mp4';
        } else if (type === 'session_15') {
            videoSrc = 'https://storage.googleapis.com/emsd_video/5_0902_0900_Samira_Sub_2.mp4';
        } else if (type === 'session_16') {
            videoSrc = 'https://storage.googleapis.com/emsd_video/6_0910_1400_Stephen%20White_Sub_2.mp4';
        } else if (type === 'session_17') {
            videoSrc = 'https://storage.googleapis.com/emsd_video/7_0927_0930_ATAL_Sub_2.mp4';
        } else if (type === 'session_18') {
            videoSrc = 'https://storage.googleapis.com/emsd_video/8_Zeng%20Jia_Huawei.mp4';
        } else if (type === 'session_19') {
            videoSrc = 'https://storage.googleapis.com/emsd_video/9_0917_0730_Dr%20Vrabie_Sub.mp4';
        } else if (type === 'session_20') {
            videoSrc = 'https://storage.googleapis.com/emsd_video/10_0917_1500_Dr%20Cheng%20Feng_Sub_2.mp4';
        } else if (type === 'session_22') {
            videoSrc = 'https://storage.googleapis.com/emsd_video/12_0930_1000_WSP_Sub_3.mp4';
        } else if (type === 'session_23') {
            videoSrc = 'https://storage.googleapis.com/emsd_video/13_Kevin_Kelly_CIBSE_Sub.mp4';
        } else if (type === 'session_24') {
            videoSrc = 'https://storage.googleapis.com/emsd_video/14_ChenGuanSheng_GuangdongUniversity.mp4';
        } else if (type === 'session_25') {
            videoSrc = 'https://storage.googleapis.com/emsd_video/15_Dr.DingLiHeng.mp4';
        }

        let video = document.getElementById('video');

        video.setAttribute('src', videoSrc + "?autoPlay=1&amp;modestbranding=1&amp;showinfo=0");
    }
    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
        setInterval(() => {
            if (this.state.why1) {
                this.updateWhy(2);
            } else if (this.state.why2) {
                this.updateWhy(3);
            } else if (this.state.why3) {
                this.updateWhy(4);
            } else if (this.state.why4) {
                this.updateWhy(5);
            } else {
                this.updateWhy(1);
            }
        }, 3000);
        let myModal = document.getElementById('myModal');
        let video = document.getElementById('video');

        myModal.addEventListener('hide.bs.modal', function () {
            video.setAttribute('src', '');
        });

        var path = window.location.pathname
        path = path.slice(1, 3);
        if (path === 'en') {
            require("./conf.css");
        } else if (path === 'sc') {
            require("./conf_sc.css");
        } else if (path === 'tc') {
            require("./conf_tc.css");
        }
        var sub = window.location.hash;
        sub = sub.slice(1);
        this.goToSection(sub);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
        let myModal = document.getElementById('myModal');
        let video = document.getElementById('video');

        myModal.removeEventListener('hide.bs.modal', function () {
            video.setAttribute('src', '');
        });
        this.setState=()=>false;
    }

    render() {
        const { t } = this.props;
        const { row, why1, why2, why3, why4, why5 } = this.state;
        return (
            <div className="d-flex justify-content-center">
                <MetaTags>
                    <title>{t('conf-meta-title')}</title>
                    <meta name="title" content={t('conf-meta-title')} />
                    <meta name="description" content={t('conf-meta-description')} />
                    <meta name="keywords" content={t('conf-meta-keywords')} />
                </MetaTags>
                <div id="conference">
                    <div className="conf-banner">
                        <div className="container-fluid d-flex justify-content-center align-items-center">
                            <div>
                                <div className={t('conf-banner-headline-1 text-center TXT_medium')}>{t('conf-banner-headline-1')}</div>
                                <div className={t('conf-banner-headline-2 text-center TXT_medium')}>{t('conf-banner-headline-2')}</div>
                                <div className={t('conf-banner-headline-3 text-center TXT_normal_medium')}>{t('conf-banner-headline-3-1')}<br className="d-md-none" />{t('conf-banner-headline-3-2')}</div>
                                <div className={t('conf-banner-headline-4 text-center TXT_bold')}>{t('conf-banner-headline-4')}</div>
                                <div className="d-flex justify-content-center">
                                    <a className="no_border" onClick={() => this.goToProgram()}><button className={t('btn_getYourPass TXT_medium')}>{t('Get Your Free Pass Now 2')}</button></a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <RollingLogo />
                    <div id="conf-intro">
                        <div className="container-fluid-1 d-flex justify-content-end conf-intro-top-right-msg">{t('conf-intro-top-right-msg')}</div>
                        <div className="container-fluid d-flex justify-content-center div-conf-intro">
                            <div className="col-12 col-lg-10">
                                <div className="conf-intro-text"><span className={t('TXT_bold')}>{t('conf-intro-text-1')}</span><span>{t('conf-intro-text-2')}</span><br /><br /></div>
                                <div className="conf-intro-text">{t('conf-intro-text-3')}<br /><br /></div>
                                <div className="d-flex justify-content-start">
                                    <a className="no_border" onClick={() => this.goToProgram()}><button className={t('btn_Register TXT_medium')}>{t('Register Now 2')}</button></a>
                                </div>
                            </div>
                        </div>
                        <div className="d-flex align-items-end div-conf-intro-banner">
                            <div className="conf-intro-banner">
                            </div>
                        </div>
                    </div>
                    <div id="theme">
                        <div className="conf-theme-background">
                            <div className="container-fluid d-flex justify-content-center">
                                <div className="col-12 col-lg-10">
                                    <div className={t('conf-theme-headline text-center TXT_medium')}>{t('conf-theme-headline')}</div>
                                    <div className="conf-theme-text text-center">{t('conf-theme-text')}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="programme">
                        <div className={t('conf-rundown-headline text-center TXT_medium')}>{t('conf-rundown-headline')}</div>
                        <div className={t('conf-rundown-date text-center TXT_bold')}>{t('conf-rundown-date')}</div>

                        <div className="container-fluid d-flex justify-content-center">
                            <div className="col-6 d-flex justify-content-end">
                                <div className="div-conf-rundown-part" onClick={() => this.updatePart(1)}>
                                    <div className={t('conf-rundown-part-name TXT_medium')}>{t('conf-rundown-part-name-1')}</div>
                                    <div className={t('conf-rundown-part-time')}><span className={t('TXT_bold_medium')}>{t('conf-rundown-part-time-1')}</span></div>
                                    <div className={this.state.part1 ? "conf-rundown-part-border-1" : "conf-rundown-part-border-2"}></div>
                                    <div className="conf-rundown-part-info">{t('conf-rundown-part-info-1')}</div>
                                </div>
                            </div>
                            <div className="div-conf-rundown-part-gap"></div>
                            <div className="col-6 d-flex justify-content-start">
                                <div className="div-conf-rundown-part" onClick={() => this.updatePart(2)}>
                                    <div className={t('conf-rundown-part-name TXT_medium')}>{t('conf-rundown-part-name-2')}</div>
                                    <div className={t('conf-rundown-part-time')}><span className={t('TXT_bold_medium')}>{t('conf-rundown-part-time-2')}</span></div>
                                    <div className={this.state.part1 ? "conf-rundown-part-border-2" : "conf-rundown-part-border-1"}></div>
                                    <div className="conf-rundown-part-info">{t('conf-rundown-part-info-2')}</div>
                                </div>
                            </div>
                        </div>
                        <div className={this.state.part1 ? "conf-rundown-detail" : "conf-rundown-detail d-none"}>
                            <div className="container-fluid d-flex justify-content-center">
                                <div className="div-conf-rundown-detail-headerline col-12 col-lg-10">
                                    <div className={t('conf-rundown-detail-headerline text-center TXT_medium_bold')}>{t('conf-rundown-detail-headerline-1')}</div>
                                </div>
                            </div>
                            <div className="container-fluid">
                                <div className="div-conf-rundown-detail-prorgram col-12 col-lg-10 d-flex">
                                    <div className={t('conf-rundown-detail-prorgram-time-xl text-end TXT_bold')}>{t('conf-rundown-detail-prorgram-time-1')}</div>
                                    <div className="conf-rundown-detail-program-break d-flex justify-content-center">
                                        <div>
                                            <div className="conf-rundown-detail-program-break-light-xl"></div>
                                            <div className="conf-rundown-detail-program-break-line"></div>
                                        </div>
                                    </div>
                                    <div className="conf-rundown-detail-program-info">
                                        <div>
                                            <div className={t('conf-rundown-detail-prorgram-info-title TXT_bold')}>{t('conf-rundown-detail-prorgram-title-1')}</div>
                                            <div className={t('conf-rundown-detail-prorgram-replay TXT_bold d-flex align-self-center')} data-bs-toggle="modal" data-bs-target="#myModal" role="button" onClick={() => this.updateVideo('session_1')}><span>{t('conf-rundown-detail-prorgram-text-replay')}</span><div className="replay-icon"></div></div>
                                        </div>
                                        <div className={t('conf-rundown-detail-prorgram-info-text TXT_bold')}>
                                            <span className="d-block">{t('conf-rundown-detail-prorgram-detail-1-1')}</span>
                                            <span className="d-block">{t('conf-rundown-detail-prorgram-detail-1-2')}</span>
                                            <span className="d-block">{t('conf-rundown-detail-prorgram-detail-1-3')}</span>
                                            <span className="d-block">{t('conf-rundown-detail-prorgram-detail-1-4')}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="div-conf-rundown-detail-prorgram-sm col-12 col-lg-10 d-flex">
                                    <div className={t('conf-rundown-detail-prorgram-time-xl text-end TXT_bold')}>{t('conf-rundown-detail-prorgram-time-2')}</div>
                                    <div className="conf-rundown-detail-program-break d-flex justify-content-center">
                                        <div>
                                            <div className="conf-rundown-detail-program-break-light-xl"></div>
                                        </div>
                                    </div>
                                    <div className="conf-rundown-detail-program-info">
                                        <div className={t('conf-rundown-detail-prorgram-info-title TXT_bold')}>{t('conf-rundown-detail-prorgram-title-2')}</div>
                                    </div>
                                </div>
                                <div className="div-conf-rundown-detail-prorgram col-12 col-lg-10 d-flex">
                                    <div className={t('conf-rundown-detail-prorgram-time text-end TXT_bold')}>{t('conf-rundown-detail-prorgram-time-2')}</div>
                                    <div className="conf-rundown-detail-program-break d-flex justify-content-center">
                                        <div>
                                            <div className="conf-rundown-detail-program-break-light"></div>
                                            <div className="conf-rundown-detail-program-break-line"></div>
                                        </div>
                                    </div>
                                    <div className="conf-rundown-detail-program-info">
                                        <div className="conf-rundown-detail-prorgram-info-text">
                                            <div>
                                                <span className={t('TXT_bold d-block conf-rundown-detail-prorgram-info-text-row')}>{t('conf-rundown-detail-prorgram-topic-2')}</span>
                                                <div className={t('conf-rundown-detail-prorgram-replay TXT_bold d-flex align-self-center')} data-bs-toggle="modal" data-bs-target="#myModal" role="button" onClick={() => this.updateVideo('session_2')}><span>{t('conf-rundown-detail-prorgram-text-replay')}</span><div className="replay-icon"></div></div>
                                            </div>
                                            <span>{t('conf-rundown-detail-prorgram-text-speaker')}</span>
                                            <span className={t('conf-rundown-detail-prorgram-text-xl TXT_bold d-block d-md-inline')}>{t('conf-rundown-detail-prorgram-speaker-2')}</span><br />
                                            <span>{t('conf-rundown-detail-prorgram-detail-2')}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="div-conf-rundown-detail-prorgram col-12 col-lg-10 d-flex">
                                    <div className={t('conf-rundown-detail-prorgram-time text-end TXT_bold')}>{t('conf-rundown-detail-prorgram-time-3')}</div>
                                    <div className="conf-rundown-detail-program-break d-flex justify-content-center">
                                        <div>
                                            <div className="conf-rundown-detail-program-break-light"></div>
                                            <div className="conf-rundown-detail-program-break-line"></div>
                                        </div>
                                    </div>
                                    <div className="conf-rundown-detail-program-info">
                                        <div className="conf-rundown-detail-prorgram-info-text">
                                            <div>
                                                <span className={t('TXT_bold d-block conf-rundown-detail-prorgram-info-text-row')}>{t('conf-rundown-detail-prorgram-topic-3')}</span>
                                                <div className={t('conf-rundown-detail-prorgram-replay TXT_bold d-flex align-self-center')} data-bs-toggle="modal" data-bs-target="#myModal" role="button" onClick={() => this.updateVideo('session_3')}><span>{t('conf-rundown-detail-prorgram-text-replay')}</span><div className="replay-icon"></div></div>
                                            </div>
                                            <span>{t('conf-rundown-detail-prorgram-text-speaker')}</span>
                                            <span className={t('conf-rundown-detail-prorgram-text-xl TXT_bold d-block d-md-inline')}>{t('conf-rundown-detail-prorgram-speaker-3')}</span><br />
                                            <span>{t('conf-rundown-detail-prorgram-detail-3')}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="div-conf-rundown-detail-prorgram col-12 col-lg-10 d-flex">
                                    <div className={t('conf-rundown-detail-prorgram-time text-end TXT_bold')}>{t('conf-rundown-detail-prorgram-time-4')}</div>
                                    <div className="conf-rundown-detail-program-break d-flex justify-content-center">
                                        <div>
                                            <div className="conf-rundown-detail-program-break-light"></div>
                                            <div className="conf-rundown-detail-program-break-line"></div>
                                        </div>
                                    </div>
                                    <div className="conf-rundown-detail-program-info">
                                        <div className="conf-rundown-detail-prorgram-info-text">
                                            <div>
                                                <span className={t('TXT_bold d-block conf-rundown-detail-prorgram-info-text-row')}>{t('conf-rundown-detail-prorgram-topic-4')}</span>
                                                <div className={t('conf-rundown-detail-prorgram-replay TXT_bold d-flex align-self-center')} data-bs-toggle="modal" data-bs-target="#myModal" role="button" onClick={() => this.updateVideo('session_4')}><span>{t('conf-rundown-detail-prorgram-text-replay')}</span><div className="replay-icon"></div></div>
                                            </div>
                                            <span>{t('conf-rundown-detail-prorgram-text-speaker')}</span>
                                            <span className={t('conf-rundown-detail-prorgram-text-xl TXT_bold d-block d-md-inline')}>{t('conf-rundown-detail-prorgram-speaker-4')}</span><br />
                                            <span>{t('conf-rundown-detail-prorgram-detail-4')}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="div-conf-rundown-detail-prorgram col-12 col-lg-10 d-flex">
                                    <div className={t('conf-rundown-detail-prorgram-time text-end TXT_bold')}>{t('conf-rundown-detail-prorgram-time-5')}</div>
                                    <div className="conf-rundown-detail-program-break d-flex justify-content-center">
                                        <div>
                                            <div className="conf-rundown-detail-program-break-light"></div>
                                            <div className="conf-rundown-detail-program-break-line"></div>
                                        </div>
                                    </div>
                                    <div className="conf-rundown-detail-program-info">
                                        <div className="conf-rundown-detail-prorgram-info-text">
                                            <div>
                                                <span className={t('TXT_bold d-block conf-rundown-detail-prorgram-info-text-row')}>{t('conf-rundown-detail-prorgram-topic-5')}</span>
                                                <div className={t('conf-rundown-detail-prorgram-replay TXT_bold d-flex align-self-center')} data-bs-toggle="modal" data-bs-target="#myModal" role="button" onClick={() => this.updateVideo('session_5')}><span>{t('conf-rundown-detail-prorgram-text-replay')}</span><div className="replay-icon"></div></div>
                                            </div>
                                            <span>{t('conf-rundown-detail-prorgram-text-speaker')}</span>
                                            <span className={t('conf-rundown-detail-prorgram-text-xl TXT_bold d-block d-md-inline')}>{t('conf-rundown-detail-prorgram-speaker-5')}</span><br />
                                            <span>{t('conf-rundown-detail-prorgram-detail-5')}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="div-conf-rundown-detail-prorgram col-12 col-lg-10 d-flex">
                                    <div className={t('conf-rundown-detail-prorgram-time text-end TXT_bold')}>{t('conf-rundown-detail-prorgram-time-6')}</div>
                                    <div className="conf-rundown-detail-program-break d-flex justify-content-center">
                                        <div>
                                            <div className="conf-rundown-detail-program-break-light"></div>
                                            <div className="conf-rundown-detail-program-break-line"></div>
                                        </div>
                                    </div>
                                    <div className="conf-rundown-detail-program-info">
                                        <div className="conf-rundown-detail-prorgram-info-text">
                                            <div>
                                                <span className={t('TXT_bold d-block conf-rundown-detail-prorgram-info-text-row')}>{t('conf-rundown-detail-prorgram-topic-6')}</span>
                                                <div className={t('conf-rundown-detail-prorgram-replay TXT_bold d-flex align-self-center')} data-bs-toggle="modal" data-bs-target="#myModal" role="button" onClick={() => this.updateVideo('session_6')}><span>{t('conf-rundown-detail-prorgram-text-replay')}</span><div className="replay-icon"></div></div>
                                            </div>
                                            <span>{t('conf-rundown-detail-prorgram-text-speaker')}</span>
                                            <span className={t('conf-rundown-detail-prorgram-text-xl TXT_bold d-block d-md-inline')}>{t('conf-rundown-detail-prorgram-speaker-6')}</span><br />
                                            <span>{t('conf-rundown-detail-prorgram-detail-6')}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="div-conf-rundown-detail-prorgram col-12 col-lg-10 d-flex">
                                    <div className={t('conf-rundown-detail-prorgram-time text-end TXT_bold')}>{t('conf-rundown-detail-prorgram-time-7')}</div>
                                    <div className="conf-rundown-detail-program-break d-flex justify-content-center">
                                        <div>
                                            <div className="conf-rundown-detail-program-break-light"></div>
                                            <div className="conf-rundown-detail-program-break-line"></div>
                                        </div>
                                    </div>
                                    <div className="conf-rundown-detail-program-info">
                                        <div className="conf-rundown-detail-prorgram-info-text">
                                            <div>
                                                <span className={t('TXT_bold d-block conf-rundown-detail-prorgram-info-text-row')}>{t('conf-rundown-detail-prorgram-topic-7')}</span>
                                                <div className={t('conf-rundown-detail-prorgram-replay TXT_bold d-flex align-self-center')} data-bs-toggle="modal" data-bs-target="#myModal" role="button" onClick={() => this.updateVideo('session_7')}><span>{t('conf-rundown-detail-prorgram-text-replay')}</span><div className="replay-icon"></div></div>
                                            </div>
                                            <span>{t('conf-rundown-detail-prorgram-text-speaker')}</span>
                                            <span className={t('conf-rundown-detail-prorgram-text-xl TXT_bold d-block d-md-inline')}>{t('conf-rundown-detail-prorgram-speaker-7')}</span><br />
                                            <span>{t('conf-rundown-detail-prorgram-detail-7')}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="div-conf-rundown-detail-prorgram col-12 col-lg-10 d-flex">
                                    <div className={t('conf-rundown-detail-prorgram-time text-end TXT_bold')}>{t('conf-rundown-detail-prorgram-time-8')}</div>
                                    <div className="conf-rundown-detail-program-break d-flex justify-content-center">
                                        <div>
                                            <div className="conf-rundown-detail-program-break-light"></div>
                                            <div className="conf-rundown-detail-program-break-line"></div>
                                        </div>
                                    </div>
                                    <div className="conf-rundown-detail-program-info">
                                        <div className="conf-rundown-detail-prorgram-info-text">
                                            <div>
                                                <span className={t('TXT_bold d-block conf-rundown-detail-prorgram-info-text-row')}>{t('conf-rundown-detail-prorgram-topic-8')}</span>
                                                <div className={t('conf-rundown-detail-prorgram-replay TXT_bold d-flex align-self-center')} data-bs-toggle="modal" data-bs-target="#myModal" role="button" onClick={() => this.updateVideo('session_8')}><span>{t('conf-rundown-detail-prorgram-text-replay')}</span><div className="replay-icon"></div></div>
                                            </div>
                                            <span>{t('conf-rundown-detail-prorgram-text-speaker')}</span>
                                            <span className={t('conf-rundown-detail-prorgram-text-xl TXT_bold d-block d-md-inline')}>{t('conf-rundown-detail-prorgram-speaker-8')}</span><br />
                                            <span>{t('conf-rundown-detail-prorgram-detail-8')}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="div-conf-rundown-detail-prorgram col-12 col-lg-10 d-flex">
                                    <div className={t('conf-rundown-detail-prorgram-time text-end TXT_bold')}>{t('conf-rundown-detail-prorgram-time-9')}</div>
                                    <div className="conf-rundown-detail-program-break d-flex justify-content-center">
                                        <div>
                                            <div className="conf-rundown-detail-program-break-light"></div>
                                            <div className="conf-rundown-detail-program-break-line"></div>
                                        </div>
                                    </div>
                                    <div className="conf-rundown-detail-program-info">
                                        <div className="conf-rundown-detail-prorgram-info-text">
                                            <div>
                                                <span className={t('TXT_bold d-block conf-rundown-detail-prorgram-info-text-row')}>{t('conf-rundown-detail-prorgram-topic-9')}</span>
                                                <div className={t('conf-rundown-detail-prorgram-replay TXT_bold d-flex align-self-center')} data-bs-toggle="modal" data-bs-target="#myModal" role="button" onClick={() => this.updateVideo('session_9')}><span>{t('conf-rundown-detail-prorgram-text-replay')}</span><div className="replay-icon"></div></div>
                                            </div>
                                            <span>{t('conf-rundown-detail-prorgram-text-speaker')}</span>
                                            <span className={t('conf-rundown-detail-prorgram-text-xl TXT_bold d-block d-md-inline')}>{t('conf-rundown-detail-prorgram-speaker-9')}</span><br />
                                            <span>{t('conf-rundown-detail-prorgram-detail-9')}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={this.state.part1 ? "conf-rundown-detail d-none" : "conf-rundown-detail"}>
                            <div className="container-fluid d-flex justify-content-center">
                                <div className="div-conf-rundown-detail-headerline col-12 col-lg-10">
                                    <div className={t('conf-rundown-detail-headerline text-center TXT_medium_bold')}>{t('conf-rundown-detail-headerline-2')}</div>
                                </div>
                            </div>
                            <div className="container-fluid">
                                <div className="div-conf-rundown-detail-prorgram col-12 col-lg-10 d-flex">
                                    <div className={t('conf-rundown-detail-prorgram-time-xl text-end TXT_bold')}>{t('conf-rundown-detail-prorgram-time-10')}</div>
                                    <div className="conf-rundown-detail-program-break d-flex justify-content-center">
                                        <div>
                                            <div className="conf-rundown-detail-program-break-light-xl"></div>
                                            <div className="conf-rundown-detail-program-break-line"></div>
                                        </div>
                                    </div>
                                    <div className="conf-rundown-detail-program-info">
                                        <div className={t('conf-rundown-detail-prorgram-info-title TXT_bold')}>{t('conf-rundown-detail-prorgram-title-2')}</div>
                                        <div className={t('conf-rundown-detail-prorgram-info-text TXT_bold')}>
                                            <span className="d-block">{t('conf-rundown-detail-prorgram-detail-10')}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="div-conf-rundown-detail-prorgram col-12 col-lg-10 d-flex">
                                    <div className={t('conf-rundown-detail-prorgram-time text-end TXT_bold')}>{t('conf-rundown-detail-prorgram-time-10')}</div>
                                    <div className="conf-rundown-detail-program-break d-flex justify-content-center">
                                        <div>
                                            <div className="conf-rundown-detail-program-break-light"></div>
                                            <div className="conf-rundown-detail-program-break-line"></div>
                                        </div>
                                    </div>
                                    <div className="conf-rundown-detail-program-info">
                                        <div className="conf-rundown-detail-prorgram-info-text">
                                            <div>
                                                <span className={t('TXT_bold d-block conf-rundown-detail-prorgram-info-text-row')}>{t('conf-rundown-detail-prorgram-topic-11')}</span>
                                                <div className={t('conf-rundown-detail-prorgram-replay TXT_bold d-flex align-self-center')} data-bs-toggle="modal" data-bs-target="#myModal" role="button" onClick={() => this.updateVideo('session_11')}><span>{t('conf-rundown-detail-prorgram-text-replay')}</span><div className="replay-icon"></div></div>
                                            </div>
                                            <span>{t('conf-rundown-detail-prorgram-text-speaker')}</span>
                                            <span className={t('conf-rundown-detail-prorgram-text-xl TXT_bold d-block d-md-inline')}>{t('conf-rundown-detail-prorgram-speaker-11')}</span><br />
                                            <span>{t('conf-rundown-detail-prorgram-detail-11')}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="div-conf-rundown-detail-prorgram col-12 col-lg-10 d-flex">
                                    <div className={t('conf-rundown-detail-prorgram-time text-end TXT_bold')}>{t('conf-rundown-detail-prorgram-time-11')}</div>
                                    <div className="conf-rundown-detail-program-break d-flex justify-content-center">
                                        <div>
                                            <div className="conf-rundown-detail-program-break-light"></div>
                                            <div className="conf-rundown-detail-program-break-line"></div>
                                        </div>
                                    </div>
                                    <div className="conf-rundown-detail-program-info">
                                        <div className="conf-rundown-detail-prorgram-info-text">
                                            <div>
                                                <span className={t('TXT_bold d-block conf-rundown-detail-prorgram-info-text-row')}>{t('conf-rundown-detail-prorgram-topic-12')}</span>
                                                <div className={t('conf-rundown-detail-prorgram-replay TXT_bold d-flex align-self-center')} data-bs-toggle="modal" data-bs-target="#myModal" role="button" onClick={() => this.updateVideo('session_12')}><span>{t('conf-rundown-detail-prorgram-text-replay')}</span><div className="replay-icon"></div></div>
                                            </div>
                                            <span>{t('conf-rundown-detail-prorgram-text-speaker')}</span>
                                            <span className={t('conf-rundown-detail-prorgram-text-xl TXT_bold d-block d-md-inline')}>{t('conf-rundown-detail-prorgram-speaker-12')}</span><br />
                                            <span>{t('conf-rundown-detail-prorgram-detail-12')}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="div-conf-rundown-detail-prorgram col-12 col-lg-10 d-flex">
                                    <div className={t('conf-rundown-detail-prorgram-time text-end TXT_bold')}>{t('conf-rundown-detail-prorgram-time-12')}</div>
                                    <div className="conf-rundown-detail-program-break d-flex justify-content-center">
                                        <div>
                                            <div className="conf-rundown-detail-program-break-light"></div>
                                            <div className="conf-rundown-detail-program-break-line"></div>
                                        </div>
                                    </div>
                                    <div className="conf-rundown-detail-program-info">
                                        <div className="conf-rundown-detail-prorgram-info-text">
                                            <div>
                                                <span className={t('TXT_bold d-block conf-rundown-detail-prorgram-info-text-row')}>{t('conf-rundown-detail-prorgram-topic-13')}</span>
                                                <div className={t('conf-rundown-detail-prorgram-replay TXT_bold d-flex align-self-center')} data-bs-toggle="modal" data-bs-target="#myModal" role="button" onClick={() => this.updateVideo('session_13')}><span>{t('conf-rundown-detail-prorgram-text-replay')}</span><div className="replay-icon"></div></div>
                                            </div>
                                            <span>{t('conf-rundown-detail-prorgram-text-speaker')}</span>
                                            <span className={t('conf-rundown-detail-prorgram-text-xl TXT_bold d-block d-md-inline')}>{t('conf-rundown-detail-prorgram-speaker-13')}</span><br />
                                            <span>{t('conf-rundown-detail-prorgram-detail-13')}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="div-conf-rundown-detail-prorgram col-12 col-lg-10 d-flex">
                                    <div className={t('conf-rundown-detail-prorgram-time text-end TXT_bold')}>{t('conf-rundown-detail-prorgram-time-13')}</div>
                                    <div className="conf-rundown-detail-program-break d-flex justify-content-center">
                                        <div>
                                            <div className="conf-rundown-detail-program-break-light"></div>
                                            <div className="conf-rundown-detail-program-break-line"></div>
                                        </div>
                                    </div>
                                    <div className="conf-rundown-detail-program-info">
                                        <div className="conf-rundown-detail-prorgram-info-text">
                                            <div>
                                                <span className={t('TXT_bold d-block conf-rundown-detail-prorgram-info-text-row')}>{t('conf-rundown-detail-prorgram-topic-14')}</span>
                                                <div className={t('conf-rundown-detail-prorgram-replay TXT_bold d-flex align-self-center')} data-bs-toggle="modal" data-bs-target="#myModal" role="button" onClick={() => this.updateVideo('session_14')}><span>{t('conf-rundown-detail-prorgram-text-replay')}</span><div className="replay-icon"></div></div>
                                            </div>
                                            <span>{t('conf-rundown-detail-prorgram-text-speaker')}</span>
                                            <span className={t('conf-rundown-detail-prorgram-text-xl TXT_bold d-block d-md-inline')}>{t('conf-rundown-detail-prorgram-speaker-14')}</span><br />
                                            <span>{t('conf-rundown-detail-prorgram-detail-14')}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="div-conf-rundown-detail-prorgram col-12 col-lg-10 d-flex">
                                    <div className={t('conf-rundown-detail-prorgram-time text-end TXT_bold')}>{t('conf-rundown-detail-prorgram-time-14')}</div>
                                    <div className="conf-rundown-detail-program-break d-flex justify-content-center">
                                        <div>
                                            <div className="conf-rundown-detail-program-break-light"></div>
                                            <div className="conf-rundown-detail-program-break-line"></div>
                                        </div>
                                    </div>
                                    <div className="conf-rundown-detail-program-info">
                                        <div className="conf-rundown-detail-prorgram-info-text">
                                            <div>
                                                <span className={t('TXT_bold d-block conf-rundown-detail-prorgram-info-text-row')}>{t('conf-rundown-detail-prorgram-topic-15')}</span>
                                                <div className={t('conf-rundown-detail-prorgram-replay TXT_bold d-flex align-self-center')} data-bs-toggle="modal" data-bs-target="#myModal" role="button" onClick={() => this.updateVideo('session_15')}><span>{t('conf-rundown-detail-prorgram-text-replay')}</span><div className="replay-icon"></div></div>
                                            </div>
                                            <span>{t('conf-rundown-detail-prorgram-text-speaker')}</span>
                                            <span className={t('conf-rundown-detail-prorgram-text-xl TXT_bold d-block d-md-inline')}>{t('conf-rundown-detail-prorgram-speaker-15')}</span><br />
                                            <span>{t('conf-rundown-detail-prorgram-detail-15')}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="div-conf-rundown-detail-prorgram col-12 col-lg-10 d-flex">
                                    <div className={t('conf-rundown-detail-prorgram-time text-end TXT_bold')}>{t('conf-rundown-detail-prorgram-time-15')}</div>
                                    <div className="conf-rundown-detail-program-break d-flex justify-content-center">
                                        <div>
                                            <div className="conf-rundown-detail-program-break-light"></div>
                                            <div className="conf-rundown-detail-program-break-line"></div>
                                        </div>
                                    </div>
                                    <div className="conf-rundown-detail-program-info">
                                        <div className="conf-rundown-detail-prorgram-info-text">
                                            <div>
                                                <span className={t('TXT_bold d-block conf-rundown-detail-prorgram-info-text-row')}>{t('conf-rundown-detail-prorgram-topic-16')}</span>
                                                <div className={t('conf-rundown-detail-prorgram-replay TXT_bold d-flex align-self-center')} data-bs-toggle="modal" data-bs-target="#myModal" role="button" onClick={() => this.updateVideo('session_16')}><span>{t('conf-rundown-detail-prorgram-text-replay')}</span><div className="replay-icon"></div></div>
                                            </div>
                                            <span>{t('conf-rundown-detail-prorgram-text-speaker')}</span>
                                            <span className={t('conf-rundown-detail-prorgram-text-xl TXT_bold d-block d-md-inline')}>{t('conf-rundown-detail-prorgram-speaker-16')}</span><br />
                                            <span>{t('conf-rundown-detail-prorgram-detail-16')}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="div-conf-rundown-detail-prorgram col-12 col-lg-10 d-flex">
                                    <div className={t('conf-rundown-detail-prorgram-time text-end TXT_bold')}>{t('conf-rundown-detail-prorgram-time-16')}</div>
                                    <div className="conf-rundown-detail-program-break d-flex justify-content-center">
                                        <div>
                                            <div className="conf-rundown-detail-program-break-light"></div>
                                            <div className="conf-rundown-detail-program-break-line"></div>
                                        </div>
                                    </div>
                                    <div className="conf-rundown-detail-program-info">
                                        <div className="conf-rundown-detail-prorgram-info-text">
                                            <div>
                                                <span className={t('TXT_bold d-block conf-rundown-detail-prorgram-info-text-row')}>{t('conf-rundown-detail-prorgram-topic-17')}</span>
                                                <div className={t('conf-rundown-detail-prorgram-replay TXT_bold d-flex align-self-center')} data-bs-toggle="modal" data-bs-target="#myModal" role="button" onClick={() => this.updateVideo('session_17')}><span>{t('conf-rundown-detail-prorgram-text-replay')}</span><div className="replay-icon"></div></div>
                                            </div>
                                            <span>{t('conf-rundown-detail-prorgram-text-speaker')}</span>
                                            <span className={t('conf-rundown-detail-prorgram-text-xl TXT_bold d-block d-md-inline')}>{t('conf-rundown-detail-prorgram-speaker-17')}</span><br />
                                            <span>{t('conf-rundown-detail-prorgram-detail-17')}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="div-conf-rundown-detail-prorgram col-12 col-lg-10 d-flex">
                                    <div className={t('conf-rundown-detail-prorgram-time text-end TXT_bold')}>{t('conf-rundown-detail-prorgram-time-17')}</div>
                                    <div className="conf-rundown-detail-program-break d-flex justify-content-center">
                                        <div>
                                            <div className="conf-rundown-detail-program-break-light"></div>
                                            <div className="conf-rundown-detail-program-break-line"></div>
                                        </div>
                                    </div>
                                    <div className="conf-rundown-detail-program-info">
                                        <div className="conf-rundown-detail-prorgram-info-text">
                                            <div>
                                                <span className={t('TXT_bold d-block conf-rundown-detail-prorgram-info-text-row')}>{t('conf-rundown-detail-prorgram-topic-18')}</span>
                                                <div className={t('conf-rundown-detail-prorgram-replay TXT_bold d-flex align-self-center')} data-bs-toggle="modal" data-bs-target="#myModal" role="button" onClick={() => this.updateVideo('session_18')}><span>{t('conf-rundown-detail-prorgram-text-replay')}</span><div className="replay-icon"></div></div>
                                            </div>
                                            <span>{t('conf-rundown-detail-prorgram-text-speaker')}</span>
                                            <span className={t('conf-rundown-detail-prorgram-text-xl TXT_bold d-block d-md-inline')}>{t('conf-rundown-detail-prorgram-speaker-18')}</span><br />
                                            <span>{t('conf-rundown-detail-prorgram-detail-18')}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="div-conf-rundown-detail-prorgram col-12 col-lg-10 d-flex">
                                    <div className={t('conf-rundown-detail-prorgram-time text-end TXT_bold')}>{t('conf-rundown-detail-prorgram-time-18')}</div>
                                    <div className="conf-rundown-detail-program-break d-flex justify-content-center">
                                        <div>
                                            <div className="conf-rundown-detail-program-break-light"></div>
                                            <div className="conf-rundown-detail-program-break-line"></div>
                                        </div>
                                    </div>
                                    <div className="conf-rundown-detail-program-info">
                                        <div className="conf-rundown-detail-prorgram-info-text">
                                            <div>
                                                <span className={t('TXT_bold d-block conf-rundown-detail-prorgram-info-text-row')}>{t('conf-rundown-detail-prorgram-topic-19')}</span>
                                                <div className={t('conf-rundown-detail-prorgram-replay TXT_bold d-flex align-self-center')} data-bs-toggle="modal" data-bs-target="#myModal" role="button" onClick={() => this.updateVideo('session_19')}><span>{t('conf-rundown-detail-prorgram-text-replay')}</span><div className="replay-icon"></div></div>
                                            </div>
                                            <span>{t('conf-rundown-detail-prorgram-text-speaker')}</span>
                                            <span className={t('conf-rundown-detail-prorgram-text-xl TXT_bold d-block d-md-inline')}>{t('conf-rundown-detail-prorgram-speaker-19')}</span><br />
                                            <span>{t('conf-rundown-detail-prorgram-detail-19')}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="div-conf-rundown-detail-prorgram col-12 col-lg-10 d-flex">
                                    <div className={t('conf-rundown-detail-prorgram-time text-end TXT_bold')}>{t('conf-rundown-detail-prorgram-time-19')}</div>
                                    <div className="conf-rundown-detail-program-break d-flex justify-content-center">
                                        <div>
                                            <div className="conf-rundown-detail-program-break-light"></div>
                                            <div className="conf-rundown-detail-program-break-line"></div>
                                        </div>
                                    </div>
                                    <div className="conf-rundown-detail-program-info">
                                        <div className="conf-rundown-detail-prorgram-info-text">
                                            <div>
                                                <span className={t('TXT_bold d-block conf-rundown-detail-prorgram-info-text-row')}>{t('conf-rundown-detail-prorgram-topic-20')}</span>
                                                <div className={t('conf-rundown-detail-prorgram-replay TXT_bold d-flex align-self-center')} data-bs-toggle="modal" data-bs-target="#myModal" role="button" onClick={() => this.updateVideo('session_20')}><span>{t('conf-rundown-detail-prorgram-text-replay')}</span><div className="replay-icon"></div></div>
                                            </div>
                                            <span>{t('conf-rundown-detail-prorgram-text-speaker')}</span>
                                            <span className={t('conf-rundown-detail-prorgram-text-xl TXT_bold d-block d-md-inline')}>{t('conf-rundown-detail-prorgram-speaker-20')}</span><br />
                                            <span>{t('conf-rundown-detail-prorgram-detail-20')}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="div-conf-rundown-detail-prorgram col-12 col-lg-10 d-flex">
                                    <div className={t('conf-rundown-detail-prorgram-time text-end TXT_bold')}>{t('conf-rundown-detail-prorgram-time-20')}</div>
                                    <div className="conf-rundown-detail-program-break d-flex justify-content-center">
                                        <div>
                                            <div className="conf-rundown-detail-program-break-light"></div>
                                            <div className="conf-rundown-detail-program-break-line"></div>
                                        </div>
                                    </div>
                                    <div className="conf-rundown-detail-program-info">
                                        <div className="conf-rundown-detail-prorgram-info-text">
                                            <span className={t('TXT_bold d-block conf-rundown-detail-prorgram-info-text-row')}>{t('conf-rundown-detail-prorgram-topic-21')}</span>
                                            <span>{t('conf-rundown-detail-prorgram-text-speaker')}</span>
                                            <span className={t('conf-rundown-detail-prorgram-text-xl TXT_bold d-block d-md-inline')}>{t('conf-rundown-detail-prorgram-speaker-21')}</span><br />
                                            <span>{t('conf-rundown-detail-prorgram-detail-21')}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="div-conf-rundown-detail-prorgram col-12 col-lg-10 d-flex">
                                    <div className={t('conf-rundown-detail-prorgram-time text-end TXT_bold')}>{t('conf-rundown-detail-prorgram-time-21')}</div>
                                    <div className="conf-rundown-detail-program-break d-flex justify-content-center">
                                        <div>
                                            <div className="conf-rundown-detail-program-break-light"></div>
                                            <div className="conf-rundown-detail-program-break-line"></div>
                                        </div>
                                    </div>
                                    <div className="conf-rundown-detail-program-info">
                                        <div className="conf-rundown-detail-prorgram-info-text">
                                            <div>
                                                <span className={t('TXT_bold d-block conf-rundown-detail-prorgram-info-text-row')}>{t('conf-rundown-detail-prorgram-topic-22')}</span>
                                                <div className={t('conf-rundown-detail-prorgram-replay TXT_bold d-flex align-self-center')} data-bs-toggle="modal" data-bs-target="#myModal" role="button" onClick={() => this.updateVideo('session_22')}><span>{t('conf-rundown-detail-prorgram-text-replay')}</span><div className="replay-icon"></div></div>
                                            </div>
                                            <span>{t('conf-rundown-detail-prorgram-text-speaker')}</span>
                                            <span className={t('conf-rundown-detail-prorgram-text-xl TXT_bold d-block d-md-inline')}>{t('conf-rundown-detail-prorgram-speaker-22')}</span><br />
                                            <span>{t('conf-rundown-detail-prorgram-detail-22')}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="div-conf-rundown-detail-prorgram col-12 col-lg-10 d-flex">
                                    <div className={t('conf-rundown-detail-prorgram-time text-end TXT_bold')}>{t('conf-rundown-detail-prorgram-time-22')}</div>
                                    <div className="conf-rundown-detail-program-break d-flex justify-content-center">
                                        <div>
                                            <div className="conf-rundown-detail-program-break-light"></div>
                                            <div className="conf-rundown-detail-program-break-line"></div>
                                        </div>
                                    </div>
                                    <div className="conf-rundown-detail-program-info">
                                        <div className="conf-rundown-detail-prorgram-info-text">
                                            <div>
                                                <span className={t('TXT_bold d-block conf-rundown-detail-prorgram-info-text-row')}>{t('conf-rundown-detail-prorgram-topic-23')}</span>
                                                <div className={t('conf-rundown-detail-prorgram-replay TXT_bold d-flex align-self-center')} data-bs-toggle="modal" data-bs-target="#myModal" role="button" onClick={() => this.updateVideo('session_23')}><span>{t('conf-rundown-detail-prorgram-text-replay')}</span><div className="replay-icon"></div></div>
                                            </div>
                                            <span>{t('conf-rundown-detail-prorgram-text-speaker')}</span>
                                            <span className={t('conf-rundown-detail-prorgram-text-xl TXT_bold d-block d-md-inline')}>{t('conf-rundown-detail-prorgram-speaker-23')}</span><br />
                                            <span>{t('conf-rundown-detail-prorgram-detail-23')}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="div-conf-rundown-detail-prorgram col-12 col-lg-10 d-flex">
                                    <div className={t('conf-rundown-detail-prorgram-time text-end TXT_bold')}>{t('conf-rundown-detail-prorgram-time-23')}</div>
                                    <div className="conf-rundown-detail-program-break d-flex justify-content-center">
                                        <div>
                                            <div className="conf-rundown-detail-program-break-light"></div>
                                            <div className="conf-rundown-detail-program-break-line"></div>
                                        </div>
                                    </div>
                                    <div className="conf-rundown-detail-program-info">
                                        <div className="conf-rundown-detail-prorgram-info-text">
                                            <div>
                                                <span className={t('TXT_bold d-block conf-rundown-detail-prorgram-info-text-row')}>{t('conf-rundown-detail-prorgram-topic-24')}</span>
                                                <div className={t('conf-rundown-detail-prorgram-replay TXT_bold d-flex align-self-center')} data-bs-toggle="modal" data-bs-target="#myModal" role="button" onClick={() => this.updateVideo('session_24')}><span>{t('conf-rundown-detail-prorgram-text-replay')}</span><div className="replay-icon"></div></div>
                                            </div>
                                            <span>{t('conf-rundown-detail-prorgram-text-speaker')}</span>
                                            <span className={t('conf-rundown-detail-prorgram-text-xl TXT_bold d-block d-md-inline')}>{t('conf-rundown-detail-prorgram-speaker-24')}</span><br />
                                            <span>{t('conf-rundown-detail-prorgram-detail-24')}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="div-conf-rundown-detail-prorgram col-12 col-lg-10 d-flex">
                                    <div className={t('conf-rundown-detail-prorgram-time text-end TXT_bold')}>{t('conf-rundown-detail-prorgram-time-24')}</div>
                                    <div className="conf-rundown-detail-program-break d-flex justify-content-center">
                                        <div>
                                            <div className="conf-rundown-detail-program-break-light"></div>
                                            <div className="conf-rundown-detail-program-break-line"></div>
                                        </div>
                                    </div>
                                    <div className="conf-rundown-detail-program-info">
                                        <div className="conf-rundown-detail-prorgram-info-text">
                                            <div>
                                                <span className={t('TXT_bold d-block conf-rundown-detail-prorgram-info-text-row')}>{t('conf-rundown-detail-prorgram-topic-25')}</span>
                                                <div className={t('conf-rundown-detail-prorgram-replay TXT_bold d-flex align-self-center')} data-bs-toggle="modal" data-bs-target="#myModal" role="button" onClick={() => this.updateVideo('session_25')}><span>{t('conf-rundown-detail-prorgram-text-replay')}</span><div className="replay-icon"></div></div>
                                            </div>
                                            <span>{t('conf-rundown-detail-prorgram-text-speaker')}</span>
                                            <span className={t('conf-rundown-detail-prorgram-text-xl TXT_bold d-block d-md-inline')}>{t('conf-rundown-detail-prorgram-speaker-25')}</span><br />
                                            <span>{t('conf-rundown-detail-prorgram-detail-25')}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Speaker row={row} />
                    <div id="audience">
                        <div className="container-fluid">
                            <div className={t('conf-target-headline text-center TXT_medium')}>{t('conf-target-headline-1')}</div>

                            <div className="conf-target-info-1st-row d-flex justify-content-center">
                                <div className="conf-target-info">
                                    <div className="d-flex justify-content-center"><img src={Conf_1} className="conf-target-info-img" alt="" /></div>
                                    <div className="d-flex justify-content-center">
                                        <div className={t('conf-target-info-title text-center TXT_medium')}>{t('conf-target-info-title-1')}</div>
                                    </div>
                                </div>
                                <div className="conf-target-info">
                                    <div className="d-flex justify-content-center"><img src={Conf_2} className="conf-target-info-img" alt="" /></div>
                                    <div className="d-flex justify-content-center">
                                        <div className={t('conf-target-info-title text-center TXT_medium')}>{t('conf-target-info-title-2')}</div>
                                    </div>
                                </div>
                                <div className="conf-target-info">
                                    <div className="d-flex justify-content-center"><img src={Conf_3} className="conf-target-info-img" alt="" /></div>
                                    <div className="d-flex justify-content-center">
                                        <div className={t('conf-target-info-title text-center TXT_medium')}>{t('conf-target-info-title-3')}</div>
                                    </div>
                                </div>
                                <div className="conf-target-info">
                                    <div className="d-flex justify-content-center"><img src={Conf_4} className="conf-target-info-img" alt="" /></div>
                                    <div className="d-flex justify-content-center">
                                        <div className={t('conf-target-info-title text-center TXT_medium')}>{t('conf-target-info-title-4')}</div>
                                    </div>
                                </div>
                            </div>
                            <div className="conf-target-info-2nd-row">
                                <div className="conf-target-info-xl d-flex justify-content-center">
                                    <div className="d-flex justify-content-center"><img src={Conf_5} className="conf-target-info-img" alt="" /></div>
                                    <div className={t('conf-target-info-title-xl d-flex align-items-center TXT_medium')}>{t('conf-target-info-title-5')}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="why">
                        <div className="container-fluid">
                            <div className={t('conf-why-headline text-center TXT_medium')}>{t('conf-why-headline-1')}</div>

                            <div className="d-flex justify-content-center">
                                <div className={why1 ? 'conf-why-info' : 'conf-why-info d-none'}>
                                    <div className="d-flex justify-content-center"><img src={Why_1} className="conf-why-info-img" alt="" /></div>
                                    <div className="d-flex justify-content-center">
                                        <div className={t('conf-why-info-title text-center TXT_bold')}>{t('conf-why-info-title-1')}</div>
                                    </div>
                                </div>
                                <div className={why2 ? 'conf-why-info' : 'conf-why-info d-none'}>
                                    <div className="d-flex justify-content-center"><img src={Why_2} className="conf-why-info-img" alt="" /></div>
                                    <div className="d-flex justify-content-center">
                                        <div className={t('conf-why-info-title text-center TXT_bold')}>{t('conf-why-info-title-2')}</div>
                                    </div>
                                </div>
                                <div className={why3 ? 'conf-why-info' : 'conf-why-info d-none'}>
                                    <div className="d-flex justify-content-center"><img src={Why_3} className="conf-why-info-img" alt="" /></div>
                                    <div className="d-flex justify-content-center">
                                        <div className={t('conf-why-info-title text-center TXT_bold')}>{t('conf-why-info-title-3')}</div>
                                    </div>
                                </div>
                                <div className={why4 ? 'conf-why-info' : 'conf-why-info d-none'}>
                                    <div className="d-flex justify-content-center"><img src={Why_4} className="conf-why-info-img" alt="" /></div>
                                    <div className="d-flex justify-content-center">
                                        <div className={t('conf-why-info-title text-center TXT_bold')}>{t('conf-why-info-title-4')}</div>
                                    </div>
                                </div>
                                <div className={why5 ? 'conf-why-info' : 'conf-why-info d-none'}>
                                    <div className="d-flex justify-content-center"><img src={Why_5} className="conf-why-info-img" alt="" /></div>
                                    <div className="d-flex justify-content-center">
                                        <div className={t('conf-why-info-title text-center TXT_bold')}>{t('conf-why-info-title-5')}</div>
                                    </div>
                                </div>

                            </div>
                            <div className="conf-why-line">
                                <div className="d-flex justify-content-center">
                                    <div>
                                        <div className="conf-why-line-btn-1" onClick={() => this.updateWhy(1)}></div>
                                        <div className="d-flex justify-content-center">
                                            <div className={why1 ? 'conf-why-line-tri-1' : 'conf-why-line-tri-1 d-none'}></div>
                                        </div>
                                    </div>
                                    <div className="conf-why-line-gap align-self-center"></div>
                                    <div>
                                        <div className="conf-why-line-btn-2" onClick={() => this.updateWhy(2)}></div>
                                        <div className="d-flex justify-content-center">
                                            <div className={why2 ? 'conf-why-line-tri-2' : 'conf-why-line-tri-2 d-none'}></div>
                                        </div>
                                    </div>
                                    <div className="conf-why-line-gap align-self-center"></div>
                                    <div>
                                        <div className="conf-why-line-btn-3" onClick={() => this.updateWhy(3)}></div>
                                        <div className="d-flex justify-content-center">
                                            <div className={why3 ? 'conf-why-line-tri-3' : 'conf-why-line-tri-3 d-none'}></div>
                                        </div>
                                    </div>
                                    <div className="conf-why-line-gap align-self-center"></div>
                                    <div>
                                        <div className="conf-why-line-btn-4" onClick={() => this.updateWhy(4)}></div>
                                        <div className="d-flex justify-content-center">
                                            <div className={why4 ? 'conf-why-line-tri-4' : 'conf-why-line-tri-4 d-none'}></div>
                                        </div>
                                    </div>
                                    <div className="conf-why-line-gap align-self-center"></div>
                                    <div>
                                        <div className="conf-why-line-btn-5" onClick={() => this.updateWhy(5)}></div>
                                        <div className="d-flex justify-content-center">
                                            <div className={why5 ? 'conf-why-line-tri-5' : 'conf-why-line-tri-5 d-none'}></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="d-flex justify-content-center">
                                <a className="no_border" onClick={() => this.goToProgram()}><button className={t('btn_regConf TXT_medium')}>{t('Register for the Conference Now')}</button></a>
                            </div>
                        </div>
                    </div>
                    <Footer />
                    {/* <ConfTimer date="10/12/2021 09:30 GMT+8" /> */}
                </div>
                {/*  Modal */}
                <div className="modal fade" id="myModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-body">
                                <div className="d-flex justify-content-end">
                                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                </div>

                                <div className="ratio ratio-16x9">
                                    <video autoPlay playsInline controls src="" id="video">
                                        <source src="" type="video/mp4"/>
                                    </video>
                                    {/* <iframe className="embed-responsive-item" src="" id="video" allowscriptaccess="always" title="Video"></iframe> */}
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>



        );
    }
}

// extended main view with translate hoc
export default translate("translations")(Conf);



// WEBPACK FOOTER //
// ./src/components/pages/conf.js